module.exports = __webpack_public_path__ + "static/img/header-red-bg.e9de211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/header-red-bg.png
// module id = AEF9
// module chunks = 216